import User from "./User.jsx";

export default User;
